import React, { useEffect, useState } from "react";
import AdminLayout from "../components/AdminLayout";
import { api } from "../lib/api";

export default function AdminDashboard() {
  const [contacts, setContacts] = useState([]);
  const [investors, setInvestors] = useState([]);
  const [tab, setTab] = useState("investors");
  const [error, setError] = useState("");

  useEffect(() => {
    Promise.all([
      api.get("/admin/contact-inquiries"),
      api.get("/admin/investor-inquiries"),
    ])
      .then(([c, i]) => { setContacts(c.data); setInvestors(i.data); })
      .catch((e) => setError(e.response?.data?.detail || e.message));
  }, []);

  const rows = tab === "investors" ? investors : contacts;

  return (
    <AdminLayout title={<>Inquiry <em className="text-primary italic">pipeline.</em></>}>
      <div className="flex gap-3 mb-6">
        <button data-testid="admin-tab-investors" onClick={() => setTab("investors")} className={`px-5 py-3 text-[12px] uppercase tracking-[0.22em] border transition-colors ${tab === "investors" ? "bg-primary text-primary-foreground border-primary" : "border-primary/30 text-primary hover:bg-primary/10"}`}>
          Investor ({investors.length})
        </button>
        <button data-testid="admin-tab-contacts" onClick={() => setTab("contacts")} className={`px-5 py-3 text-[12px] uppercase tracking-[0.22em] border transition-colors ${tab === "contacts" ? "bg-primary text-primary-foreground border-primary" : "border-primary/30 text-primary hover:bg-primary/10"}`}>
          Contact ({contacts.length})
        </button>
      </div>

      {error && <div className="text-destructive text-sm mb-4">{error}</div>}

      <div className="glass overflow-x-auto">
        <table className="w-full text-sm" data-testid="admin-inquiries-table">
          <thead className="border-b border-primary/20">
            <tr className="text-left">
              <th className="overline px-6 py-4">Date</th>
              <th className="overline px-6 py-4">Name</th>
              <th className="overline px-6 py-4">Email</th>
              {tab === "investors" ? (
                <>
                  <th className="overline px-6 py-4">Type</th>
                  <th className="overline px-6 py-4">Range</th>
                  <th className="overline px-6 py-4">Project</th>
                </>
              ) : (
                <>
                  <th className="overline px-6 py-4">Category</th>
                  <th className="overline px-6 py-4">Subject</th>
                </>
              )}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={6} className="px-6 py-12 text-center text-muted-foreground">No inquiries yet.</td></tr>
            )}
            {rows.map((r) => (
              <tr key={r.id} className="border-b border-primary/5 hover:bg-background/30 transition-colors">
                <td className="px-6 py-4 font-mono text-xs text-foreground/60">{new Date(r.created_at).toLocaleString()}</td>
                <td className="px-6 py-4">{r.name}</td>
                <td className="px-6 py-4 text-primary font-mono text-xs">{r.email}</td>
                {tab === "investors" ? (
                  <>
                    <td className="px-6 py-4 text-foreground/70">{r.investor_type}</td>
                    <td className="px-6 py-4 text-foreground/70">{r.investment_range}</td>
                    <td className="px-6 py-4 text-foreground/70">{r.project_interest || "—"}</td>
                  </>
                ) : (
                  <>
                    <td className="px-6 py-4 text-foreground/70">{r.category}</td>
                    <td className="px-6 py-4 text-foreground/70">{r.subject || "—"}</td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}
